export const scopeOptions = [
  { label: "bicycle:read", value: "bicycle:read" },
  { label: "bicycle:write", value: "bicycle:write" },
  { label: "trip:read", value: "trip:read" },
  { label: "organization:read", value: "organization:read" },
  { label: "zone:read", value: "zone:read" },
  { label: "support-ticket:read", value: "support-ticket:read" },
  { label: "lock:write", value: "lock:write" },
  { label: "support-ticket:write", value: "support-ticket:write" },
]
